import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CalendarComponent from "../../components/agenda/CalendarComponent";
import { API_ADMIN, API_tecnicos } from "../../config/apiConfig";
import Navbar from "../../components/Navbar";
import ModalAgendarCita from "../../components/dashboard_tecnico/ModalAgendarCita";
import ModalDetallesCita from "../../components/agenda/ModalDetallesCita";
import "./css/Agenda.css";

const Agenda = () => {
  const { user, role ,token} = useSelector((state) => state.auth);
  const [view, setView] = useState("month");
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedCita, setSelectedCita] = useState(null);

  useEffect(() => {
    const fetchCitas = async () => {
      try {
        // !logic was change to allow not only technicians but also admins
        const isAllowed = ["administrador", "tecnico-1", "tecnico-2"].includes(role);
        if (!isAllowed) return;
        let citas;
        // Obtener citas del técnico
        if (role === "administrador") {
          const resCitas = await fetch(`${API_ADMIN}/${user?.id}/citas`,{
             method: 'GET',
          headers: {
            "x-auth-token": token,
          },
          });
          citas = await resCitas.json();
        } else {
          const resCitas = await fetch(`${API_tecnicos}/${user?.id}/citas`);
          citas = await resCitas.json();
        }

        console.log("citas", citas);
        // Filtrar y mapear citas aceptadas con todos los datos
        const citasAceptadas = citas
          .filter((c) => c.state?.toLowerCase() === "aceptado")
          .map((cita) => {
            const startDate = new Date(cita.appointmentDate);
            const endDate = new Date(cita.appointmentDate);
            console.log("x");
            // Si la fecha no tiene hora específica, usar una hora por defecto
            if (startDate.getHours() === 0 && startDate.getMinutes() === 0) {
              startDate.setHours(9, 0, 0, 0); // 9:00 AM por defecto
              endDate.setHours(10, 0, 0, 0); // 10:00 AM por defecto
            } else {
              // Añadir al menos 1 hora de duración al evento para que sea visible
              endDate.setHours(endDate.getHours() + 1);
            }

            const eventObj = {
              title: cita.subject,
              user: cita.name,
              DNI: cita.dni,
              start: startDate,
              end: endDate,
              allDay: false, // Añadir esta propiedad para eventos con horario específico
              // Guardar todos los datos de la cita para el modal
              citaCompleta: cita,
            };

            return eventObj;
          });

        setEvents(citasAceptadas);
      } catch (error) {
        console.error("Error al cargar citas");
      }
    };

    if (user && role) {
      fetchCitas();
    }
  }, [user, role]);

  // Callback para cuando se crea una nueva cita
  const handleCitaCreada = (nuevaCita) => {
    setEvents([...events, nuevaCita]);
  };

  // Manejar clic en evento del calendario
  const handleEventClick = (event) => {
    setSelectedCita(event.citaCompleta);
    setShowDetailsModal(true);
  };

  return (
    <>
      <Navbar />

      <main className="agenda">
        <button className="boton nueva-cita absolute" onClick={() => setShowModal(true)}>
          Agendar nueva cita
        </button>

        <CalendarComponent events={events} view={view} onViewChange={setView} onSelectEvent={handleEventClick} />

        <ModalAgendarCita isOpen={showModal} onClose={() => setShowModal(false)} onCitaCreada={handleCitaCreada} />

        <ModalDetallesCita isOpen={showDetailsModal} onClose={() => setShowDetailsModal(false)} cita={selectedCita} />
      </main>
    </>
  );
};

export default Agenda;
